import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { lightTheme } from 'theme/index';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import SVG from 'react-inlinesvg';

const CTASVG = styled(SVG)`
  max-height: 36px;
  vertical-align: middle;
  display: inline-block;
  margin-bottom: -2px;
  svg {
    width: 24px;
    height: 24px;

    path,
    g,
    polygon {
      fill: ${props => props.theme.palette.primary.main};
    }
  }
`;

const CTATitle = styled(Typography)`
  margin: 6px 0;
`;

const CTATypography = styled(Typography)`
  display: block;
`;

export const CTAButton = styled(
  ({ stacked, cta, theme = lightTheme, ...other }) => (
    <Button
      href={cta.link.href}
      color="primary"
      size="large"
      target="_blank"
      stacked={stacked}
      fullWidth
      data-swiftype-index="false"
      {...other}
    >
      <CTATitle component="span" variant="subtitle2">
        {cta.icon && <CTASVG src={cta.icon.url} theme={theme} alt="Icon" />}{' '}
        {cta.link.title}{' '}
      </CTATitle>
      <CTATypography component="span" variant="caption">
        {cta.text}
      </CTATypography>
    </Button>
  )
)`
  > span {
    flex-direction: column;
    align-items: flex-start;
    @media (min-width: 600px) {
      align-items: ${props => (props.stacked ? 'flex-start' : 'center')};
      text-align: ${props => (props.stacked ? 'left' : 'center')};
    }
  }
`;

const CallsToAction = ({ actionItems, stacked, theme = lightTheme }) => {
  return (
    <Grid
      container
      spacing={stacked ? 0 : 40}
      alignItems="flex-start"
      justify="center"
      data-swiftype-index="false"
    >
      {(actionItems || []).map((cta, idx) => {
        return (
          <Grid item xs={12} sm={stacked ? 12 : 6} key={idx}>
            <CTAButton stacked={stacked} cta={cta} theme={theme} />
          </Grid>
        );
      })}
    </Grid>
  );
};

CallsToAction.defaultProps = {
  stacked: false
};

CallsToAction.propTypes = {
  actionItems: PropTypes.arrayOf(PropTypes.object),
  theme: PropTypes.object,
  stacked: PropTypes.bool
};

export default CallsToAction;
